export { make as DecidrToast } from "./Primitives__DecidrToast.gen";
